var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { dark, phoneSecondaryColor, borderRadius } from './constants';
export default styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: 0 3px\n    ", ";\n  border-radius: ", ";\n  position: absolute;\n  width: 125px;\n  height: 30px;\n  left: 0;\n  right: 0;\n  bottom: 17px;\n  margin: 0 auto;\n  transition: all 0.1s linear;\n\n  &:active {\n    box-shadow: 0 0px\n      ", ";\n    transform: translateY(4px);\n  }\n"], ["\n  background-color: ",
    ";\n  box-shadow: 0 3px\n    ",
    ";\n  border-radius: ", ";\n  position: absolute;\n  width: 125px;\n  height: 30px;\n  left: 0;\n  right: 0;\n  bottom: 17px;\n  margin: 0 auto;\n  transition: all 0.1s linear;\n\n  &:active {\n    box-shadow: 0 0px\n      ",
    ";\n    transform: translateY(4px);\n  }\n"])), function (props) {
    return props.color ? props.color : dark;
}, function (props) {
    return props.shadowColor ? props.shadowColor : phoneSecondaryColor;
}, borderRadius, function (props) {
    return props.shadowColor ? props.shadowColor : phoneSecondaryColor;
});
var templateObject_1;
//# sourceMappingURL=HomeButton.js.map